import { Lasku } from '@lemon/core-firebase/model/lasku'
import { LocalDate, NumberDate, NumberMonth, Timestamp } from '@lemon/core/model/common'

/**
 * Yhteisömyynti-ilmoituksen uuden toiminnallisuuden aloituspäivämäärä.
 * Kuukausia ennen tätä päivämäärää ei käsitellä automaattisesti yhteisömyyntejä kirjauksiin
 * eikä näytetä yhteisömyynti-välilehteä kirjanpito sivulla.
 */
export const YHTEISOMYYNTI_ALOITUSPVM: LocalDate = { year: 2026, month: 3, day: 1 }

// customers/{asiakasAvain}/yhteisomyynti-ilmoitukset/{lahetysAvain}
export interface OmaveroYhteisomyyntilaskuLahetetty {
  /** Jokaista lähetysyritystä varten generoitu avain */
  lahetysAvain: string
  /** Asiakkaan, jonka ilmoitusta lähetetään, avain */
  asiakasAvain: string
  /** Sen työjonodatan avain, jonka ajamisen seurauksena tämä luotiin */
  tyojonoAvain: string
  tallentajaAvain: string
  jakso: NumberMonth
  status: 'success' | 'error'
  lahetetty: Timestamp
  rivit: OmaveroYhteisomyyntilaskuLahetettyRivi[]
}

export interface OmaveroYhteisomyyntilaskuLahetettyRivi {
  maaKoodi: string
  alvTunnus: string
  tavaramyynnit: number
  palvelumyynnit: number
  /**
   * Kolmikantamyynnit eivät ole käytössä meidän järjestelmässä vielä, mutta pidetään kenttä valmiina
   * tulevaisuutta varten.
   */
  kolmikantamyynnit: number
}

// customers/{asiakasAvain}/yhteisomyynti-ilmoitukset/{lahetysAvain}/yhteisomyynti-ilmoitukset-debug-data/{lahetysAvain}
export interface OmaveroYhteisomyyntilaskuLahetettyDebugData extends OmaveroYhteisomyyntilaskuLahetetty {
  /** @deprecated Vanha kenttä laskupohjaiselle lähestymistavalle. Käytä draftJakso-kenttää uusissa toteutuksissa */
  laskut?: Lasku[]
  /** Lähetyksessä käytetty draftin jakso. Asetettu kun käytetään draft-pohjaista lähestymistapaa */
  draftJakso?: NumberMonth
  /** Tilannevedos draft-datasta lähetyshetkellä (auditointia varten) */
  draftSnapshot?: string // THIS IS JSON.stringify(OmaveroYhteisomyyntiDraft)
  request: string // THIS IS JSON.stringify(ECSalesListFilingRequest)
  response: string // THIS IS JSON.stringify(ECSalesListFilingResponse)
}

export interface OmaveroYhteisomyyntiDraftPuuttuvaVat {
  kirjausAvain: string
  kirjausnumero: string
  kirjausPvm: NumberDate
}

// DRAFT: asiakkaat/{asiakasAvain}/yhteisomyynti-ilmoitukset-draft/{YYYYMM}
// Reuse the sent type but omit fields that don't make sense for drafts
export interface OmaveroYhteisomyyntiDraft extends Omit<OmaveroYhteisomyyntilaskuLahetetty, 'lahetysAvain' | 'tyojonoAvain' | 'status' | 'lahetetty' | 'tallentajaAvain'> {
  tavaramyynnitYhteensa: number
  palvelumyynnitYhteensa: number
  kolmikantamyynnitYhteensa: number
  puuttuvatVatKirjaukset?: OmaveroYhteisomyyntiDraftPuuttuvaVat[]
  lahetysvirhe?: string
  tarvitseeLahetyksen?: boolean
}
